import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { Stack } from 'components/Stack'
import { pxToRem } from 'utils/styled'
import { Button } from 'components/button/Button'

export const SFutureMessageCard = styled.div`
  position: relative;
  width: 100%;
  min-height: ${pxToRem(400)}rem;
  display: flex;
`

export const SFutureMessageWrapper = styled.div`
  position: relative;
  flex: 1 1 10rem;
  min-width: 10rem;
`

export const SFutureMessageContent = styled(Button)`
  width: 100%;
  height: 100%;
  min-height: 8.5rem;
  padding: 0;

  & > span {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
`

export const SFutureMessageImageArea = styled.div`
  position: relative;
  width: 100%;
  height: 11.75rem;
  min-height: 11.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--c-gray300);

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const SFutureMessageStack = styled(Stack)`
  width: 100%;
  height: 100%;
  padding: 0.75rem 1.25rem 1.25rem;
`

export const SFutureMessageTitle = styled(Text)`
  color: var(--c-black);
  font-weight: 700;
  font-size: 1.0625rem;
  line-height: 1.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
`

export const SFutureMessageParagraph = styled(Text)`
  flex: 1;
`

export const SFutureMessageSmallText = styled(Text)`
  font-size: 0.8125rem;
  line-height: 1.25rem;
`

export const SFutureMessageStatus = styled.div`
  width: 100%;
  margin-top: auto;
`

export const SFutureMessageShareWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: end;
`

export const SFutureMessageLockedWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 1rem;
  background: var(--c-gray300-transparent);
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  cursor: pointer;
`
